import { render, staticRenderFns } from "./v-sheet.vue?vue&type=template&id=6244d446&scoped=true&"
import script from "./v-sheet.vue?vue&type=script&lang=ts&"
export * from "./v-sheet.vue?vue&type=script&lang=ts&"
import style0 from "./v-sheet.vue?vue&type=style&index=0&id=6244d446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244d446",
  null
  
)

export default component.exports